import {cargoApiURL} from '@logistics-frontend/client-core/api/corp'
import {CardScope} from '@logistics-frontend/types/schemas/cargo-corp/definitions/cards-info'
import {equals, find, flow, get, head, pipe, raise} from '@logistics-frontend/utils'

import {CardPayloadResponse} from '../types'
import {fetchBoundedCards} from './fetch-bounded-cards'
import {fetchCardList} from './fetch-card-list'

async function _fetchCards(
  clientId: string,
  scopes: CardScope[],
  country?: string,
  makeUrl = cargoApiURL,
): Promise<CardPayloadResponse> {
  const boundedCards = await fetchBoundedCards(clientId, {scopes}, country, makeUrl)
  const cards = await fetchCardList(clientId, country, makeUrl)

  const boundedCardId = pipe(boundedCards, head, get('card_id'))
  const boundedCard = pipe(cards, find(flow(get('id'), equals(boundedCardId))))

  cards.sort(card => (card === boundedCard ? -1 : 0))

  return {
    card: boundedCard,
    cards,
  }
}

export function fetchCards(clientId: string, cardScope?: string, country?: string, makeUrl = cargoApiURL) {
  if (cardScope === 'agent_scheme' || cardScope === 'direct_debiting') {
    return _fetchCards(clientId, [{kind: cardScope}], country, makeUrl)
  }

  return raise('Unknown card scope')
}
